import { Injectable } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import additionalQuestionsForm from '@app/forms/subscription/services/additionalQuestionsForm';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: any, option) {
    return additionalQuestionsForm.generatForm(entity, this.formBuilder);
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  get accountInformations() {
    return this.form.get('accountInformations') as UntypedFormArray;
  }
  extract() {
    return { ...this.form.value };
  }
}
